import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Modal, Button } from 'react-bootstrap';
import styles from './styles.css';


class UniModal extends Component {
  constructor(props) {
    super(props);
    this.state = {
      shown: false,
      opened: false,
    };
    this.open = this.open.bind(this);
    this.close = this.close.bind(this);
    this.exited = this.exited.bind(this);
  }

  open() {
    this.setState({ opened: true, shown: true });
  }
  
  close() {
    this.setState({ opened: false });
  }
  
  exited() {
    this.setState({ shown: false });
  }

  renderModal() {
    const { shown, opened } = this.state;
    if (!shown) {
      return null;
    }
    const { children, title, footer, size } = this.props;
    return (
      <Modal bsSize={size} key="modal" show={opened} onHide={this.close} onExited={this.exited}>
        {title !== null && <Modal.Header closeButton>{title}</Modal.Header>}
        <Modal.Body>
          {shown && children}
        </Modal.Body>
        <Modal.Footer className="clearfix">
          {footer !== null && <div className="pull-left">{footer}</div>}
          <Button className="pull-right" bsStyle="default" onClick={this.close}>Done</Button>
        </Modal.Footer>
      </Modal>
    );
  }


  render() {
    const { anchor } = this.props;
    return [
      (
        <span onClick={this.open} key="main" className={`text-active ${styles.popoverAnchor}`}>
          {anchor}
        </span>
      ),
      this.renderModal(),
    ];
  }
}

UniModal.propTypes = {
  children: PropTypes.node,
  anchor: PropTypes.node,
  title: PropTypes.node,
  footer: PropTypes.node,
  size: PropTypes.string,
};
UniModal.defaultProps = {
  children: null,
  anchor: null,
  title: null,
  size: null,
  footer: null,
};
UniModal.contextTypes = {
};


export default UniModal;
